<template>
	<div id="subjects" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">
						<span v-if="form.id > 0">Gebruiker bewerken</span>
						<span v-else>Gebruiker Aanmaken</span>
					</section>
				</header>
				<div class="card-content">
					<div class="content">
						<section>
							<form id="form">
								<b-field label="Type Gebruiker" horizontal>
									<b-select placeholder="Kies een type" v-model="form.tbl_sys_userrol.role_id">
										<option
											v-for="option in roles"
											:value="option.id"
											:key="option.id"
											:loading="loading_schools"
										>{{ option.name }}</option>
									</b-select>
								</b-field>
								<b-field label="Gebruikers Naam" horizontal>
									<b-input v-model="form.displayname" style="width:300px;"></b-input>
								</b-field>
								<b-field label="Username" horizontal>
									<b-input v-model="form.username" style="width:200px;"></b-input>
								</b-field>
								<b-field label="Password" horizontal>
									<b-input v-model="form.password" style="width:200px;"></b-input>
								</b-field>
								<b-field label="Email" horizontal>
									<b-input v-model="form.email" style="width:300px;"></b-input>
								</b-field>
								<b-field label="School" horizontal>
									<b-select placeholder="Kies een school" v-model="form.i_school_id">
										<option
											v-for="option in schools"
											:value="option.id"
											:key="option.id"
											:loading="loading_schools"
										>{{option.schoolnumber}} - {{ option.name }}</option>
									</b-select>
								</b-field>
								<b-field label="Klas" horizontal>
									<b-select
										v-model="form.i_class_id"
										filterable
										placeholder="Kies ..."
										:loading="loading_classes"
									>
										<option v-for="item in classes" :key="item.id" :value="item.id">Testgroep - {{item.name}}</option>
									</b-select>
								</b-field>
								<b-field horizontal>
									<b-checkbox v-model="form.firstlogin">Firstlogin</b-checkbox>
								</b-field>
								<b-field horizontal>
									<b-checkbox v-model="form.locked_system">Vergendeld</b-checkbox>
								</b-field>
								<b-field horizontal>
									<b-field grouped>
										<b-field>
											<a class="button is-light" @click="$router.go(-1);">Terug</a>
										</b-field>
										<b-field>
											<a class="button is-primary" @click="submitForm(id)">Opslaan</a>
										</b-field>
									</b-field>
								</b-field>
							</form>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

 <script>
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "subjects",
	props: ["id"],
	data() {
		return {
			school_id: localStorage.getItem("school_id"),
			schooltype_id: localStorage.getItem("schooltype_id"),
			user: Cookies.getJSON("user"),
			schools: [],
			classes: [],
			roles: [],
			levels: [],
			grades: [],
			subjecttypes: [],
			studies: [],
			loading_schools: false,
			loading_classes: false,
			form: {
				id: 0,
				tbl_sys_userrol: { role_id: 0 }
			}
		};
	},
	created: function() {
		var self = this;
		this.getSchools();
		this.getRoles();

		if (this.id > 0) {
			this.getUser();
		}
	},
	watch: {
		"form.i_school_id": function(val) {
			console.log("school_id:" + val);

			this.getClasses(val);
			Cookies.set("selected_school", val);
		}
	},
	computed: {
		school() {
			return this.$store.getters.getSchool;
		},
		schooltype() {
			return this.$store.getters.getSchoolType;
		}
	},
	methods: {
		getUser() {
			var self = this;
			instance.get("/user/" + this.id).then(function(response) {
				self.form = response.data.data;
				console.log(self.form);
				console.log("User ...");
			});
		},
		getClasses: function(id) {
			var self = this;

			this.loading_classes = true;
			self.classes = [];
			self.studentData = [];
			instance.get("/class/school/" + id).then(function(response) {
				console.log(response.data.data);
				var obj = response.data.data;

				for (let i = 0; i < obj.length; i++) {
					const element = obj[i];
					console.log(element);
					self.classes.push({
						id: element.id,
						name: element.testgroup + " - " + element.name
					});
				}
				console.log(self.classes);
				self.loading_classes = false;
			});
		},
		getRoles: function() {
			var self = this;

			instance.get("/role").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);
				console.log(self.roles);
				self.roles = response.data.data;
			});
		},
		getSchools: function() {
			var self = this;
			self.loading_schools = true;
			instance.get("/school").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);
				console.log(self.schools);

				var schools = _.remove(response.data.data, function(n) {
					return n.schoolnumber > 0;
				});
				schools = _.sortBy(schools, [
					function(o) {
						return o.schoolnumber;
					}
				]);
				self.schools = schools;

				self.loading_schools = false;
			});
		},
		submitForm(formName) {
			var self = this;

			if (self.id > 0) {
				instance.post("/user/update", self.form).then(function(response) {
					console.log(self.user);
					console.log("Updates new schoolsector!!");

					self.$router.push({
						path: "/lock"
					});
				});
			} else {
				instance.post("/user", self.form).then(function(response) {
					console.log("Create new school year!!");

					self.$router.push({
						path: "/lock"
					});
				});
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
};
</script>
